export const mesPrestations=[
  {
    namePrestation:'Création de votre site vitrine ',
    coutPrestation: '250€',
    modeFacturation:'/day',
    titlePrestation:'Création de votre site vitrine ',
    detailPrestation:['- Développement de votre site vitrine', <br key='1'></br>,
      '- Développement de votre landing pages',]
  },
  {
    namePrestation:'Réalisation de maquettes',
    coutPrestation: '150€',
    modeFacturation:'/day ',
    titlePrestation:'Réalisation de 3 maquettes ',
    detailPrestation:['- Réalisation de 3 wireframes',<br key='2'></br>,
      '- Réalisation de 3 maquettes', <br key='3'></br>,
      '- Choix de la maquette finale']
  },
  {
    namePrestation:'Réalisation de votre flyers',
    coutPrestation: '150€',
    modeFacturation:'/day ',
    titlePrestation:'Réalisation de votre flyer',
    detailPrestation:['- Réalisation de 3 flyers',<br key='4'></br>,
      '- Réalisation de votre flyer final',]
  },
  {
    namePrestation:'Réallisation de votre site complet',
    coutPrestation: '',
    modeFacturation:'sur devis*  ',
    titlePrestation:'Réallisation de votre site complet',
    detailPrestation:['- Réalisation de 3 wireframes',<br key='5'></br>,
      ' - Réalisation de 3 maquettes', <br key='8'></br>,
      '- Choix de la maquette finale qui deviendra votre site',<br key='6'></br>,
      '- Développement de votre site vitrine', <br key='7'></br>,
      '- Développement de votre landing pages', <br key='5'></br>,
      '* Selon spécificités',]
  },
  // {
  //   namePrestation:'Community manager',
  //   coutPrestation: '150€',
  //   modeFacturation:'/day ',
  //   titlePrestationy:'Community manager',
  //   detailPrestation:[
  //     '- Réponse sur les réseaux sociaux aux commentaires',<br key='9'></br>,
  //     '- Diffusion de vos contenus sur votre page',<br key='9'></br>,
  //     '- Diffusion de vos contenus sur les groupes que vous suivez', <br key='8'></br>,
  //   ]
  // },
 
];